import { CouponGroupListApiResponse } from '@navio/nsdk';
import { URLKeys } from 'noddi-async';
import { type FilterOptionSource, usePagination } from 'noddi-ui-web';
import { useDebounceValue } from 'noddi-util';
import { toFilterOptionSource, useFilterOptionsGet } from '../useFilterOptionsGet';

/** Coupon groups as filter options, searchable. For `unit.multiSelect`. */
export const useCouponGroupOptions = (): FilterOptionSource<number> => {
  const { pageIndex, pageSize, search, setSearch } = usePagination();
  const debouncedSearch = useDebounceValue({ value: search, delay: 300 });

  const query = useFilterOptionsGet({
    type: URLKeys.getPaginatedCouponGroups,
    input: { pageIndex, pageSize, search: debouncedSearch },
    queryConfig: { select: toCouponGroupOptions }
  });

  return toFilterOptionSource(query, 'number', { search, onSearch: setSearch });
};

const toCouponGroupOptions = ({ results }: CouponGroupListApiResponse) =>
  results.map((couponGroup) => ({ value: couponGroup.id, label: couponGroup.nameInternal }));
